<template>
  <div class="con">
    <div class="oneCon">
      <div class="one">
        <div class="left">
          <p>{{ $t("foot").title0 }}</p>
          <p>{{ $t("foot").title1 }}</p>
          <input
            type="text"
            :placeholder="$t('foot').title4"
            v-model="form.email"
          />
        </div>
        <div class="line"></div>
        <div class="center">
          <p>{{ $t("foot").title3 }}</p>
          <p @click="send">
            <span>{{ $t("foot").title5 }}</span>
            <i class="iconfont icon-jt"></i>
          </p>
        </div>
        <div class="right">
          <img src="../assets/home/code.png" alt />
          <p>{{ $t("foot").title6 }}</p>
          <p>{{ $t("foot").title7 }}</p>
        </div>
      </div>
    </div>
    <div class="twoCon">
      <div class="two">
        <div class="left">
          <div>
            <img src="../assets/home/footLogo.png" alt />
            <p></p>
          </div>
          <div class="phone">
            <div class="pl">
              <p class="ph">400-880-9017</p>
              <p>NRELL MARKETING DEPARTMENT</p>
            </div>
            <div class="pr">
              <p>徐经理 <span>132-7372-8989</span></p>
              <p>徐经理 <span>186-2593-8988</span></p>
              <p>固定电话 <span>0373-8938-999</span></p>
            </div>
          </div>
        </div>
        <div class="right">
          <p @click="goto(0, -1)">产品</p>
          <p v-for="(i, ind) in prolist" :key="ind" @click="goto(0, i.id)">
            {{ i.classname }}
          </p>
        </div>
        <div class="right">
          <p @click="goto(1, -1)">解决方案</p>
          <p v-for="(i, ind) in caselist" :key="ind" @click="goto(1, i.id)">
            {{ i.classname }}
          </p>
        </div>
        <div class="right">
          <p @click="goto(2, -1)">服务</p>
          <p v-for="(i, ind) in servicelist" :key="ind" @click="goto(2, i.id)">
            {{ i.classname }}
          </p>
        </div>
        <div class="right">
          <p @click="goto(3, -1)">公司简介</p>
          <p v-for="(i, ind) in aboutList" :key="ind" @click="goto(3, ind)">
            {{ i }}
          </p>
        </div>
        <div class="right">
          <p @click="goto(4, -1)">新闻媒体</p>
          <p v-for="(i, ind) in newslist" :key="ind" @click="goto(4, i.id)">
            {{ i.classname }}
          </p>
        </div>
        <div class="right">
          <p @click="goto(5, -1)">联系我们</p>
        </div>
      </div>
    </div>
    <div class="main1">
      <div class="left">
        <i class="iconfont icon-tubiao-"></i>
        <i class="iconfont icon-tuite"></i>
        <i class="iconfont icon-ins"></i>
        <i class="iconfont icon-youtobe" style="font-size: 25px"></i>
        <i class="iconfont icon-guge"></i>
      </div>
      <a href="https://beian.miit.gov.cn/" target="_blank">{{
        $t("foot").title8
      }}</a>
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41072802000539" target="_blank">
        <img src="../assets/beian.png"> 豫公网安备 41072802000539号
      </a>
      <a href="https://seniorweb.cn/" target="_blank">{{
        $t("foot").title9
      }}</a>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { getFooter } from "../util/lang";
export default {
  name: "foot",
  data() {
    return {
      form: { email: "" },
      rightList: [
        "产品",
        "解决方案",
        "服务",
        "公司简介",
        "新闻媒体",
        "联系我们",
      ],
      proList: ["box", "plastic box", "plastic box"],
      aboutList:[
              "品牌概况",
              "里程碑",
              "企业文化",
              "荣誉资质"
      ],
      caselist: [],
      newslist: [],
      prolist: [],
      servicelist: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.rightList=this.$t('foot').rightList
      // if(this.$i18n.locale === 'en'){
      //     this.getProducts('43')
      // }else{
      //     this.getProducts('42')
      // }
      this.getFoot();
    });
  },
  methods: {
    getFoot(id) {
      const url = `${getFooter()}`;
      this.$axios.get(url).then((res) => {
        this.caselist = res.data.cases_type;
        this.newslist = res.data.news_type;
        this.prolist = res.data.products_type;
        this.servicelist = res.data.services_type;
      });
    },
    send() {
      if (this.form.email === "") {
        this.$notify({
          title: "Prompt",
          message: "Please Complete",
          offset: 100,
        });
      } else {
        this.$nextTick(() => {
          const url = "/php/form.php";
          this.$axios.post(url, qs.stringify(this.form)).then((res) => {
            if (res.status == 200) {
              this.$notify({
                title: "Success",
                message: "Submitted successfully",
                offset: 100,
              });
              this.form = {
                email: "",
              };
            } else {
              this.$notify({
                title: "Failure",
                message: "Submission Failed",
                offset: 100,
              });
            }
          });
        });
      }
    },
    goto(i, n) {
      if (i == 0 && n == -1) {
        let link = `/pro.html`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 0 && n != -1) {
        let link = `/pro.html?id=${n}`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 1 && n == -1) {
        let link = `/case.html`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 1 && n != -1) {
        let link = `/case.html?id=${n}`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 2 && n == -1) {
        let link = `/tele.html`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 2 && n != -1) {
        let link = `/tele.html?id=${n}`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 3 && n == -1) {
        let link = `/about.html`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 3 && n != -1) {
        let link = `/about.html?id=${n}`;
        window.open(link, "_self"); // this.project.link
      }
      else if (i == 4 && n == -1) {
        let link = `/news.html`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 4 && n != -1) {
        let link = `/news.html?id=${n}`;
        window.open(link, "_self"); // this.project.link
      } else if (i == 5 && n == -1) {
        let link = `/contact.html`;
        window.open(link, "_self"); // this.project.link
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  background-color: #282828;
  .oneCon {
    width: 100%;
    border-bottom: 1px solid rgba(245, 245, 245, 0.3);
    padding: 50px 0;
    .one {
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      p {
        color: white;
        padding: 10px 0;
      }
      .left {
        width: 30%;
        p:nth-child(1) {
          font-family: "Fira Code Medium";
          font-weight: lighter;
        }
        p:nth-child(2) {
          font-size: 28px;
        }
        input {
          width: 100%;
          background-color: transparent;
          border: none;
          font-style: italic;
          font-size: 14px;
          color: rgba(245, 245, 245, 0.3);
          border-bottom: 1px solid rgba(245, 245, 245, 0.3);
          padding: 10px 0;
        }
        input:focus {
          border: none;
          border-bottom: 1px solid rgba(245, 245, 245, 0.3) !important;
        }
      }
      .line {
        width: 1px;
        height: 90px;
        background-color: rgba(255, 255, 255, 0.3);
        margin-top: 20px;
      }
      .center {
        padding-top: 40px;
        font-family: "Fira Code Medium";
        font-weight: lighter;
        width: 30%;
        p:nth-child(2) {
          padding-top: 20px;
          display: flex;
          flex-direction: column;
          transition: all 2s;
          cursor: pointer;
          span {
            font-size: 14px;
            transition: all 2s;
          }
          i {
            font-size: 40px;
            transition: all 2s;
          }
        }
        p:nth-child(2):hover {
          transform: translateX(30px);
          span,
          i {
            color: #f7bc30;
          }
        }
      }
      .right {
        text-align: center;
        p {
          font-family: "Fira Code Medium";
          font-weight: lighter;
          font-size: 14px;
        }
      }
    }
  }
  .twoCon {
    width: 100%;
    border-bottom: 1px solid rgba(245, 245, 245, 0.3);
    padding: 40px 0;
    .two {
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      font-size: 12px;
      // justify-content: space-between;
      .left {
        text-align: left;
        color: #b2b2b2;
        padding-top: 18px;
        img {
          width: 55%;
        }
        .phone {
          display: flex;
          margin-top: 20px;
          .pl {
            padding-right: 25px;
            p {
              color: white;
              text-align: center;
              letter-spacing: 1px;
              transition: all 2s;
            }
            .ph {
              font-size: 30px;
              // margin-top: 20px;
              padding-bottom: 24px;
            }
            p:hover {
              color: #f5ac01;
            }
          }
          .pr {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            // align-self: flex-end;
            border-left: 1px solid rgba(207, 207, 207, 0.3);
            padding-left: 25px;
            p {
              color: white;
              font-family: "Fira Code Medium";
              font-weight: lighter;
              font-size: 15px;
              span {
                font-family: "Avenir", Helvetica, Arial, sans-serif;
                font-weight: lighter;
              }
            }
          }
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        // padding-left: 30px;
        // padding-right: 30px;
        margin-left: 8%;
        text-align: left;
        p {
          cursor: pointer;
          transition: all 2s;
          color: #cfcfcf;
          text-align: center;
          line-height: 30px;
          font-family: "Fira Code Medium";
          font-weight: lighter;
          font-size: 14px;
        }
        p:first-child {
          font-size: 14px;
          color: white;
        }
        p:hover {
          color: #f5ac01;
        }
      }
      .right:nth-child(2){
        margin-left: auto;
      }
    }
  }
  .main1 {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px 0;
    .left {
      width: 10%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      i {
        font-size: 20px;
        color: #b6b6b6;
        cursor: pointer;
        transition: all 2s;
      }
      i:hover {
        color: #f5ac01;
      }
    }
    p,
    a {
      font-size: 14px;
      color: #909090;
      cursor: pointer;
      transition: all 2s;
    }
    p:hover {
      color: #f5ac01;
    }
    a:hover {
      color: #f5ac01;
    }
  }
  @media screen and (max-width:1800px) {
    .twoCon{
      .two{
        .right{
          margin-left: 7%;
        }
      }
    }
  }
  @media screen and (max-width: 1680px) {
    .twoCon {
      .two {
        width: 95%;
        .right {
          p {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
    }
  }
  @media screen and (max-width: 450px) {
    .oneCon {
      .one {
        flex-direction: column;
        .left,
        .center,
        .line {
          display: none;
        }
      }
    }
    .twoCon {
      .two {
        flex-direction: column;
        .left {
          .phone{
            flex-direction: column;
            .pl{
              padding-right: unset;
              padding-bottom: 20px;
              .ph{
                padding-bottom: 10px;
              }
            }
            .pr{
              width: 50%;
              margin: 0 auto;
              padding-left: unset;
              border: unset;
              border-top: 1px solid rgba(207, 207, 207, 0.3);
              padding-top: 20px;
              p{
                line-height: 25px;
              }
            }
          }
          div {
            text-align: center;
          }
        }
        .right {
          display: none;
        }
      }
    }
    .main1 {
      flex-direction: column;
      .left {
        width: 100%;
        padding: 10px 0;
      }
      p,
      a {
        line-height: 30px;
        text-align: center;
      }
    }
  }
}
</style>
